<div class="content" *ngIf="page">
    <h1 class="title">{{page.name}}</h1>
    <p class="description" [innerHTML]="page.content_description"></p>
</div>
